import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import ErrorBoundary from './errorBoundary';
import './index.css';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import './i18n';

// import App from './App';
import reportWebVitals from './reportWebVitals';
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const AddTrack = lazy(() => import('./addTrack.js'));
const TrackList = lazy(() => import('./trackList.js'));
const EditTrack = lazy(() => import('./editTrack.js'));
const Feedback = lazy(() => import( './feedback.js'));
const History = lazy(() => import( './history.js'));
const Category = lazy(() => import( './category.js'));
const Ranking = lazy(() => import( './ranking.js'));
const Install = lazy(() => import( './install.js'));
const Promotion = lazy(() => import( './promotion.js'));
const PopTool = lazy(() => import( './pop_tool'));
const About = lazy(() => import( './about'));
const Collection = lazy(() => import( './collection'));
const Boradcast = lazy(() => import( './broadcast'));
const Term = lazy(() => import( './term'));
const Privacy = lazy(() => import( './privacy'));
const Product = lazy(() => import( './product'));
const LinkInstall = lazy(() => import( './linkInstall'));
const PromotionTool = lazy(() => import( './promotion_tool'));
const Comparison = lazy(() => import( './comparison'));
const RegisterManual = lazy(() => import( './registerManual'));
const Prompts = lazy(() => import( './Prompts'));
const RegisterEmail = lazy(() => import( './registerEmail'));
const PdList = lazy(() => import( './pdList'));
const MixedSalePost = lazy(() => import( './mixedSalePost'));
const Home = lazy(() => import( './home'));
const NewPlugin = lazy(() => import( './newPlugin'));
const Molink = lazy(() => import( './molink'));
const AdminTelegramUsers = lazy(() => import( './AdminTelegramUsers'));
const AdminCrawlerStats = lazy(() => import( './AdminCrawlerStats'));
const AdminUserAnalytics = lazy(() => import( './AdminUserAnalytics'));
const DebugUser = lazy(() => import( './DebugUser'));
const UserDetail = lazy(() => import( './UserDetail'));

// Google OAuth related components
const LoginPage = lazy(() => import('./pages/LoginPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const AuthCallbackPage = lazy(() => import('./pages/AuthCallbackPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const UserConsentPage = lazy(() => import('./pages/UserConsentPage'));

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyBmEOq389-hegaHskm-hDbuMq9fF8F3Fmg',
    authDomain: 'myshopper-be4fa.firebaseapp.com',
    projectId: 'myshopper-be4fa',
    storageBucket: 'myshopper-be4fa.appspot.com',
    messagingSenderId: '149937205708',
    appId: '1:149937205708:web:29c671b2fc9d162bb0ad69',
    measurementId: 'G-54ETMECCCB',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Create Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const Container_idx = () => {
    return (
        <div>
            <header>
                <h1>Track</h1>
            </header>
            <div className="mainContent">
                <div className="container" style={{ opacity: 0 }}>
                    <Link to={'/trackList'}>
                        <button
                            style={{ display: 'block', margin: '20px auto' }}
                        >
                            Go To Track List
                        </button>
                    </Link>
                    <Link to={'/addTrack'}>
                        <button
                            style={{ display: 'block', margin: '20px auto' }}
                        >
                            Go To Add Track
                        </button>
                    </Link>
                    <Link to={'/editTrack'}>
                        <button
                            style={{ display: 'block', margin: '20px auto' }}
                        >
                            Go To Edit Track
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};
const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
    ReactDOM.hydrate(
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <Router>
                    <ErrorBoundary>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Routes>
                            {/* Google OAuth routes */}
                            <Route exact path="/login" element={<LoginPage />}></Route>
                            <Route exact path="/auth/callback" element={<AuthCallbackPage />}></Route>
                            <Route exact path="/profile" element={<ProfilePage />}></Route>

                            {/* Protected routes */}
                            <Route
                                exact
                                path="/trackList"
                                element={
                                    <ProtectedRoute>
                                        <TrackList />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/addTrack"
                                element={
                                    <ProtectedRoute>
                                        <AddTrack />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/editTrack"
                                element={
                                    <ProtectedRoute>
                                        <EditTrack />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/notify_history"
                                element={
                                    <ProtectedRoute>
                                        <History />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/setting"
                                element={
                                    <ProtectedRoute>
                                        <SettingsPage />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/user_consent"
                                element={
                                    <ProtectedRoute>
                                        <UserConsentPage />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            {/* Public routes */}
                            <Route exact path="/admin/telegram-users" element={<AdminTelegramUsers />}></Route>
                            <Route exact path="/admin/crawler-stats" element={<AdminCrawlerStats />}></Route>
                            <Route exact path="/admin/user-analytics" element={<AdminUserAnalytics />}></Route>
                            <Route exact path="/debug-user" element={<DebugUser />}></Route>
                            <Route exact path="/user/:userId" element={<UserDetail />}></Route>
                            <Route exact path="/feedback" element={<Feedback />}></Route>
                            <Route path="/category/:mainCategory/:subCategory" element={<Category />}></Route>
                            <Route path="/category" element={<Category />}></Route>
                            <Route exact path="/ranking" element={<Ranking />}></Route>
                            <Route exact path="/install" element={<Install />}></Route>
                            <Route exact path="/promotion" element={<Promotion />}></Route>
                            <Route exact path="/pop_tool" element={<PopTool />}></Route>
                            <Route exact path="/about" element={<About />}></Route>
                            <Route exact path="/term" element={<Term />}></Route>
                            <Route exact path="/privacy" element={<Privacy />}></Route>                
                            <Route exact path="/broadcast" element={<Boradcast />}></Route>
                            <Route exact path="/product" element={<Product />}></Route>
                            <Route exact path="/linkInstall" element={<LinkInstall />}></Route>
                            <Route exact path="/promotion_tool" element={<PromotionTool />}></Route>
                            <Route exact path="/comparison" element={<Comparison />}></Route>
                            <Route exact path="/register_manual" element={<RegisterManual />}></Route>
                            <Route exact path="/prompts" element={<Prompts />}></Route>
                            <Route exact path="/register_email" element={<RegisterEmail />}></Route>
                            <Route exact path="/pdList" element={<PdList />}></Route>
                            <Route exact path="/" element={<Home />}></Route>
                            <Route exact path="/new_plugin" element={<NewPlugin />}></Route>
                            <Route exact path="/molink/:icode" element={<Molink />}></Route>
                        </Routes>
                    </Suspense>
                    </ErrorBoundary>
                </Router>
            </AuthProvider>
        </ThemeProvider>,
        rootElement,
    );
} else {
    ReactDOM.render(
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <Router>
                    <ErrorBoundary>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Routes>
                            {/* Google OAuth routes */}
                            <Route exact path="/login" element={<LoginPage />}></Route>
                            <Route exact path="/auth/callback" element={<AuthCallbackPage />}></Route>
                            <Route exact path="/profile" element={<ProfilePage />}></Route>

                            {/* Protected routes */}
                            <Route
                                exact
                                path="/trackList"
                                element={
                                    <ProtectedRoute>
                                        <TrackList />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/addTrack"
                                element={
                                    <ProtectedRoute>
                                        <AddTrack />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/editTrack"
                                element={
                                    <ProtectedRoute>
                                        <EditTrack />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/notify_history"
                                element={
                                    <ProtectedRoute>
                                        <History />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/setting"
                                element={
                                    <ProtectedRoute>
                                        <SettingsPage />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                exact
                                path="/user_consent"
                                element={
                                    <ProtectedRoute>
                                        <UserConsentPage />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            {/* Public routes */}
                            <Route exact path="/admin/telegram-users" element={<AdminTelegramUsers />}></Route>
                            <Route exact path="/admin/crawler-stats" element={<AdminCrawlerStats />}></Route>
                            <Route exact path="/admin/user-analytics" element={<AdminUserAnalytics />}></Route>
                            <Route exact path="/debug-user" element={<DebugUser />}></Route>
                            <Route exact path="/user/:userId" element={<UserDetail />}></Route>
                            <Route exact path="/feedback" element={<Feedback />}></Route>
                            <Route path="/category/:mainCategory/:subCategory" element={<Category />}></Route>
                            <Route path="/category" element={<Category />}></Route>
                            <Route exact path="/ranking" element={<Ranking />}></Route>
                            <Route exact path="/install" element={<Install />}></Route>
                            <Route exact path="/promotion" element={<Promotion />}></Route>
                            <Route exact path="/pop_tool" element={<PopTool />}></Route>
                            <Route exact path="/about" element={<About />}></Route>
                            <Route exact path="/term" element={<Term />}></Route>
                            <Route exact path="/privacy" element={<Privacy />}></Route>                
                            <Route exact path="/collection" element={<Collection />}></Route>
                            <Route exact path="/broadcast" element={<Boradcast />}></Route>
                            <Route exact path="/product" element={<Product />}></Route>
                            <Route exact path="/linkInstall" element={<LinkInstall />}></Route>
                            <Route exact path="/promotion_tool" element={<PromotionTool />}></Route>
                            <Route exact path="/comparison" element={<Comparison />}></Route>
                            <Route exact path="/register_manual" element={<RegisterManual />}></Route>
                            <Route exact path="/prompts" element={<Prompts />}></Route>
                            <Route exact path="/register_email" element={<RegisterEmail />}></Route>
                            <Route exact path="/pdList" element={<PdList />}></Route>
                            <Route exact path="/mixed_sale_post" element={<MixedSalePost />}></Route>
                            <Route exact path="/mixed_sale_post/:post_id" element={<MixedSalePost />}></Route>
                            <Route exact path="/mixed_sale_post/:post_id/edit" element={<MixedSalePost />}></Route>
                            <Route exact path="/" element={<Home />}></Route>
                            <Route exact path="/new_plugin" element={<NewPlugin />}></Route>
                            <Route exact path="/molink/:icode" element={<Molink />}></Route>
                        </Routes>
                    </Suspense>
                    </ErrorBoundary>
                </Router>
            </AuthProvider>
        </ThemeProvider>,
        rootElement,
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
